import { Constants } from 'src/app/core/constants/constants';

export const SIDEMENU_ITEMS: SidemenuItem[] = [
    {
        title: 'global.navbar.home',
        url: '/',
        access: [Constants.USER_ROLES.admin, Constants.USER_ROLES.manager, Constants.USER_ROLES.publisher],
        icon: 'icon-menu-dashboard',
        activeRoutes: ['/']
    },
    {
        title: 'global.navbar.messages',
        url: '/messages',
        access: [Constants.USER_ROLES.admin, Constants.USER_ROLES.manager, Constants.USER_ROLES.publisher],
        icon: 'icon-menu-messages',
        activeRoutes: ['/messages', '/messages/create', '/messages/:id/update', '/messages/:id/statistics', '/messages/:id/view']
    },
    {
        title: 'global.navbar.questionnaires',
        url: '/questionnaires',
        access: [Constants.USER_ROLES.admin, Constants.USER_ROLES.manager, Constants.USER_ROLES.publisher],
        icon: 'icon-menu-dialogs',
        activeRoutes: [
            '/questionnaires',
            '/questionnaires/:id/update',
            '/questionnaires/:id/recipients',
            '/questionnaires/:id/shipment',
            '/questionnaires/:id/questions/:questionId?',
            '/questionnaires/:id/endings/:questionId?',
            '/questionnaires/:id/statistics',
            '/questionnaires/:id/view'
        ]
    },
    {
        title: 'global.navbar.knowledgecenter',
        url: '/knowledge-center',
        access: [Constants.USER_ROLES.admin, Constants.USER_ROLES.manager, Constants.USER_ROLES.publisher],
        icon: 'icon-menu-knowledge',
        activeRoutes: [
            '/knowledge-center',
            '/knowledge-center/create',
            '/knowledge-center/:id/update',
            '/knowledge-center/:id/statistics',
            '/knowledge-center/:id/view'
        ],
        module: Constants.MODULES.KNOWLEDGE_CENTER
    },
    {
        title: 'global.navbar.conversations',
        url: '/requests',
        access: [Constants.USER_ROLES.admin, Constants.USER_ROLES.ftrayResponsible],
        icon: 'icon-menu-feedback-inboxes',
        activeRoutes: ['/requests'],
        module: Constants.MODULES.CONVERSATIONS
    },
    {
        title: 'global.navbar.timeoffRequests',
        url: '/timeoff/requests',
        access: [Constants.USER_ROLES.admin, Constants.USER_ROLES.humanResources],
        icon: 'icon-menu-vacations',
        activeRoutes: ['/timeoff/:tabName'],
        module: Constants.MODULES.HOLIDAYS
    },
    {
        title: 'global.navbar.timeTracking',
        url: '/time-tracking',
        access: [Constants.USER_ROLES.admin, Constants.USER_ROLES.humanResources],
        icon: 'icon-menu-time-tracking',
        activeRoutes: ['/time-tracking', '/time-tracking/:id/detail'],
        module: Constants.MODULES.TIME_TRACKING
    },
    {
        title: 'global.navbar.documents',
        url: '/documents',
        access: [Constants.USER_ROLES.admin, Constants.USER_ROLES.documentsManager],
        icon: 'icon-menu-documents',
        activeRoutes: [
            '/documents',
            '/remote-signature',
            '/remote-signature/:id/detail',
            '/remote-signature/:id/massive-detail',
            '/upload-documents',
            '/upload-documents/activity-log',
            '/upload-documents/activity-log/:id/detail'
        ],
        module: Constants.MODULES.DOCUMENTS
    },
    {
        title: 'global.navbar.users',
        url: '/users',
        access: [Constants.USER_ROLES.admin, Constants.USER_ROLES.employeeManager],
        icon: 'icon-group',
        activeRoutes: ['/users', '/user/create', '/user/:id/update/:tabName', '/users/import-users']
    },
    {
        title: 'global.navbar.statistics',
        url: '/statistics/summary',
        access: [Constants.USER_ROLES.admin, Constants.USER_ROLES.manager, Constants.USER_ROLES.publisher],
        icon: 'icon-menu-statistics',
        activeRoutes: ['/statistics/:tabName?']
    },
    {
        id: 'menu-settings',
        title: 'global.navbar.globalSettings',
        url: '/settings',
        access: [
            Constants.USER_ROLES.admin,
            Constants.USER_ROLES.publisher,
            Constants.USER_ROLES.humanResources,
            Constants.USER_ROLES.employeeManager,
            Constants.USER_ROLES.ftrayManager,
            Constants.USER_ROLES.documentsManager,
            Constants.USER_ROLES.chatroomManager
        ],
        icon: 'icon-menu-settings',
        activeRoutes: [
            '/settings',
            '/settings/general/:tabName',
            '/settings/my-company/:tabName',
            '/settings/my-company/company/:tabName/update/:id',
            '/settings/my-company/workplace/:tabName/update/:id',
            '/settings/my-company/teams/update/:id',
            '/settings/timeoff/:tabName',
            '/settings/timeoff/schema/:id/:tabName/update',
            '/settings/users-groups',
            '/settings/users-groups/update/:id',
            '/settings/publications',
            '/settings/conversations/:tabName',
            '/settings/conversations/feedback-trays/create',
            '/settings/conversations/feedback-trays/:tabName/:id',
            '/settings/conversations/feedback-trays/questionnaire/update/:id',
            '/settings/conversations/feedback-trays/questionnaire/:id/questions/:questionId?',
            '/settings/conversations/feedback-trays/questionnaire/:id/endings/:endingId?',
            '/settings/categories',
            '/settings/categories/create',
            '/settings/categories/update/:id',
            '/settings/active-features',
            '/settings/contact-info',
            '/settings/documents/:tabName',
            '/settings/chatrooms',
            '/settings/chatroom/:tabName/update/:id',
            '/settings/time-tracking/:tabName',
            '/settings/time-tracking/schedule/:id/update/:tabName'
        ],
        class: 'sidemenu__item--bottom'
    }
];

export interface SidemenuItem {
    title: string;
    url: string;
    access: string[];
    icon: string;
    activeRoutes: string[];
    module?: string;
    isAccessible?: boolean;
    beta?: boolean;
    id?: string;
    class?: string;
}
